<template>
  <v-flex
    xs12
    sm6
    md4
    lg2
    xl2
  >
    <div id="projectBtn">
      <project-card
        :deletable="deletable"
        :card-data="projectData"
        @refresh="refresh"
      >
        <slot />
      </project-card>
    </div>
  </v-flex>
</template>

<script>
// Components
import projectCard from "../Common/ProjectCard";

export default {
  components: {
    projectCard,
  },
  props: {
    deletable: {
      type: Boolean,
      default: true,
    },
    projectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      //
    };
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>

<style></style>
